import { ComponentRef, Injectable, NgZone } from '@angular/core';
import { filter, firstValueFrom } from 'rxjs';
import { SopoTransitionComponent } from '../../components/sopo-transition/sopo-transition.component';
import { SmartAudioService } from '../smart-audio/smart-audio.service';
import { DynamicContentService } from '../dynamic-content/dynamic-content.service';

@Injectable({
    providedIn: 'root'
})
export class SopoTransitionService {
    private _opennigTransition = false;
    private _closingTransition = false;
    private _componentRef: ComponentRef<SopoTransitionComponent | null> = null;

    constructor(
        private smartAudioService: SmartAudioService,
        private dynamicContentService: DynamicContentService,
        private zone: NgZone,
    ) { }

    async openTransition(): Promise<void> {
        if (this._opennigTransition) return;
        try {
            await this.zone.run(async () => {
                if (this._componentRef) return;

                this._opennigTransition = true;

                this._componentRef = this.dynamicContentService.openTransition();
                this._componentRef.instance.ref.detectChanges();

                await firstValueFrom(this._componentRef.instance.getTransitionStateObservable().pipe(filter(state => state === 'not-closed')));

                this._componentRef.instance.closed = true;
                this._componentRef.instance.ref.detectChanges();
                this.smartAudioService.playSounds('sopo-transition-open');

                await firstValueFrom(this._componentRef.instance.getTransitionStateObservable().pipe(filter(state => state === 'closed')));

                this._opennigTransition = false;
            });
        } catch(error) {
            console.error(error);
            if (this._opennigTransition) this._opennigTransition = false;
            this.dynamicContentService.closeSopoTransition();
            this._componentRef = null;
        }
    }
    
    async closeTransition(extraTime = false): Promise<void> {
        if (this._closingTransition) return;
        try {
            await this.zone.run(async () => {
                if(!this._componentRef) return;

                this._closingTransition = true;
    
                await firstValueFrom(this._componentRef.instance.getTransitionStateObservable().pipe(filter(state => state === 'closed')));

                if (extraTime) await this.waitFor(600);
                this._componentRef.instance.closed = false;
                this._componentRef.instance.ref.detectChanges();
                this.smartAudioService.playSounds('sopo-transition-close');

                await firstValueFrom(this._componentRef.instance.getTransitionStateObservable().pipe(filter(state => state === 'not-closed')));
                this._closingTransition = false;

                this.dynamicContentService.closeSopoTransition();
                this._componentRef = null;
            });
        } catch(error) {
            console.error(error);
            if (this._closingTransition) this._closingTransition = false;
            this.dynamicContentService.closeSopoTransition();
            this._componentRef = null;
        }
    }

    private waitFor(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
